<template>
  <div class="flex-grid">
    <div class="col2">
      <div class="main_heading">
        <h3>Add/Update User Details</h3>
        <a
          class="button_create"
          href="/Users/"
        >Manage Users</a>
      </div>
      <label for="fullName">
        <b>Full Name</b>
      </label>
      <input
        v-model="fullName"
        type="text"
        placeholder="Enter Full Name"
        name="fullName"
        required
      >
      <label for="fullName">
        <b>Email</b>
      </label>
      <input
        v-model="email"
        type="text"
        placeholder="Enter Email Id"
        name="email"
      >
      <div class="form-fields">
        <label for="Role Name">
          <b>Select Role</b>
        </label>
        <br>
        <span
          v-for="(role, key) in rolesList"
          :key="key"
        >
          <input
            v-model="roleType"
            type="radio"
            :value="role.roleId"
            @change="seletedRole()"
          >
          {{ role.roleName }}
        </span>
      </div>
      <div class="form-fields">
        <Multiselect
          v-model="fasicas"
          :options="fasciasList"
          :multiple="true"
          :close-on-select="false"
          label="fasica_name"
          track-by="fasica_name"
        />
      </div>
      <a
        class="button_create"
        @click="updateProfile()"
      >{{ saveType }}</a>
    </div>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect';

export default {
  name: 'Profile',
  components: {
    Multiselect,
  },
  data() {
    return {
      isUpdate: false,
      userId: '',
      fullName: '',
      saveType: 'Create',
      email: '',
      roleType: '',
      rolesList: [],
      fasciasList: [],
      fasicas: null,
    };
  },
  mounted() {
    this.userId = this.$route.query.id;
    if (this.$route.query.id) {
      this.isUpdate = true;
      this.saveType = 'Update';
      const getProfile = fetch(`/api/users/${this.userId}`, {
        credentials: 'same-origin',
      });
      getProfile
        .then(data => data.json())
        .then((data) => {
          this.fullName = data.fullName;
          this.email = data.email;
          this.roleType = data.role_id;
          this.fasicas = data.fascias;
        });
    }

    const getfascias = fetch('/api/fascias/all', {
      credentials: 'same-origin',
    });
    getfascias
      .then(data => data.json())
      .then((data) => {
        this.fasciasList = data;
      });
    const getRoles = fetch('/api/roles/all', { credentials: 'same-origin' });
    getRoles
      .then(data => data.json())
      .then((data) => {
        this.rolesList = data;
      });
  },
  methods: {
    seletedRole() {
      if (this.roleType === 2 || this.roleType === 3) {
        this.fasicas = this.fasciasList;
      } else {
        this.fasicas = [];
      }
    },
    updateProfile() {
      if (this.fullName === '') {
        this.$toasted.error('Please Enter Employee Name', { duration: 3000 });
        return true;
      }
      if (this.email === '') {
        this.$toasted.error('Please Enter Employee Email ID', {
          duration: 3000,
        });
        return true;
      }
      if (this.roleType === '') {
        this.$toasted.error('Please Select a Role', { duration: 3000 });
        return true;
      }
      let url = '/api/createUser';
      const data = {
        fullName: this.fullName,
        email: this.email,
        role_id: this.roleType,
        fascias: this.fasicas,
      };
      let currentMethod = 'POST';
      if (this.isUpdate) {
        currentMethod = 'PUT';
        url = `/api/updateProfile/${this.userId}`;
      }

      fetch(url, {
        method: currentMethod, // or 'PUT'
        body: JSON.stringify(data), // data can be `string` or {object}!
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
      })
        .then(res => res.json())
        .catch(error => this.$toasted.error(
          `Something Went Wrong. Please try again - ${error}`,
          { duration: 3000 },
        ))
        .then(response => this.$toasted.success(response.message, { duration: 3000 }))
        .then(setTimeout(() => this.$router.push({ name: 'users' }), 3000));
      return true;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.flex-grid {
  display: flex;
  justify-content: space-between;
}

.col2 {
  width: 100%;
}
</style>
